module.exports = require("i18n-react/dist/i18n-react");